import { useEffect, useState } from 'react';
import { LaboratoryRequestItem } from '../Interfaces/LaboratoryRequestItem.intefrace';
import { LaboratoryRequestCreateFormScheme } from '../Components/LaboratoryRequestCreate/LaboratoryRequestCreateForm';

export interface ResolveHelpItem {
	wizardItemId: string;
	key: string | boolean | string[];
	name: string;
}

const ALLOWED_TYPES = ['checkbox', 'textArea', 'textField', 'groupCheckbox'];

export default function useLaboratoryRequestFormResolver(
	formScheme: LaboratoryRequestCreateFormScheme | undefined,
) {
	const [formHelpData, setFormHelpData] = useState<ResolveHelpItem[]>([]);

	const flatData = (items: LaboratoryRequestItem[]): ResolveHelpItem[] => {
		const temp: ResolveHelpItem[] = [];
		items.forEach(item => {
			if (ALLOWED_TYPES.includes(item.type) && item.value) {
				const helpItem: ResolveHelpItem = {
					wizardItemId: item.id,
					key: item.value,
					name: item.title,
				};
				temp.push(helpItem);
			}

			if (item.children && (item.children?.length || 0) > 0) {
				temp.push(...flatData(item.children));
			}
		});
		return temp;
	};

	useEffect(() => {
		if (formScheme && (formScheme?.children?.length || 0) > 0) {
			setFormHelpData(flatData(formScheme.children));
		}
	}, [formScheme]);

	return {
		formResolveHelperData: formHelpData,
	};
}
